import constants from 'Base/shared/bk/modules/constants.js';
const template = document.createElement('template');

template.innerHTML = `
<div data-loading-overlay id="loadingOverlay" class="rm-loading-dots" role="alert" aria-busy="true">
  <img src="${constants.imagesUrl}/loadingImg/loading_1.png" alt="" class="loadingDots">
  <img src="${constants.imagesUrl}/loadingImg/loading_2.png" alt="" class="loadingDots">
  <img src="${constants.imagesUrl}/loadingImg/loading_3.png" alt="" class="loadingDots">
</div>
`;

export default template;
